import React, { Fragment } from 'react';
import classnames from 'classnames';
import { translate } from 'react-i18next';
import * as Common from 'common/components';

const { Form } = Common;

const LocationsField = ({
  parent,
  location,
  handleAddLocation,
  handleValueChange,
  handleRemoveLocation,
  canEdit,
}) => {
  return (
    <div className="input-group input-group-sm">
      <input
        type="text"
        className="form-control"
        style={{ minWidth: '150px' }}
        name={'name'}
        value={location.name}
        onChange={(e) => {
          handleValueChange(location, e);
        }}
        readOnly={!canEdit || !location.active}
        required
      />
      {canEdit && (
        <div className="input-group-append">
          <a
            className="btn btn-outline-danger"
            href="#remove-location"
            onClick={(e) => {
              e.preventDefault();
              handleRemoveLocation(location);
            }}
          >
            <i className="fa fa-trash" />
          </a>
          <a
            className="btn btn-outline-success"
            href="#add-location"
            onClick={(e) => {
              e.preventDefault();
              handleAddLocation(location);
            }}
          >
            <i className="fa fa-plus" />
          </a>
        </div>
      )}
    </div>
  );
};

const LocationsTreeView = ({
  isSaving,
  isLoading,
  handleAddLocation,
  handleRemoveLocation,
  handleValueChange,
  handleSubmit,
  locations,
  permissions,
  t,
}) => {
  const canEdit = permissions['acl.locations.update'];
  const renderLocations = (locations, parent) => {
    return (
      <Fragment>
        <ul className="locations-ul">
          {canEdit && !parent && (
            <li className={'parent'}>
              <a
                className="btn btn-outline-success btn-sm"
                href={'#add-other-location'}
                onClick={(e) => {
                  e.preventDefault();
                  handleAddLocation(parent);
                }}
              >
                {t('actions.addLocation')}
              </a>
            </li>
          )}
          {locations &&
            locations
              .filter((l) => !l.deleted)
              .map((location, index) => (
                <li key={index} className={classnames({ parent: !location._parent })}>
                  <LocationsField
                    parent={parent}
                    location={location}
                    handleAddLocation={handleAddLocation}
                    handleValueChange={handleValueChange}
                    handleRemoveLocation={handleRemoveLocation}
                    canEdit={canEdit}
                  />
                  {renderLocations(location._childs, location)}
                </li>
              ))}
        </ul>
      </Fragment>
    );
  };

  return (
    <Common.Wrapper fluid={true}>
      <Common.Header title={t('locations.title')} />
      <div className="col-12">
        <Common.Portlet title={t('locations.locations_title')} icon={'map-marker'}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <div className="row">
              <div className="col-md-12 mt-3">{renderLocations(locations)}</div>
              <div className="col-md-12 mt-3">
                <Form.Button
                  type={'submit'}
                  text={t('actions.save')}
                  isLoading={isSaving}
                  disabled={isSaving}
                  extraClassName={'pull-right btn-xs-block'}
                />
                <div className="clearfix" />
              </div>
            </div>
          </form>
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(LocationsTreeView);



// WEBPACK FOOTER //
// src/modules/secured/modules/locations/components/LocationsTreeView.js